import { render, staticRenderFns } from "./ItemRow.vue?vue&type=template&id=c851311e&scoped=true&"
import script from "./ItemRow.vue?vue&type=script&lang=js&"
export * from "./ItemRow.vue?vue&type=script&lang=js&"
import style0 from "./ItemRow.vue?vue&type=style&index=0&id=c851311e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c851311e",
  null
  
)

export default component.exports